<template>
    <ul class="mt-0" id="learnLessionList">
        <li class="pdt-9 pdb-9"
            v-for="(lesson, index) in lessonsList" :key="index"
            @click="moveNextLesson(lesson)" @keypress="moveNextLesson(lesson)" tabindex="0"
            :class="{'active': lesson.progressionId === currentProgressionId}"
        >
            <!-- {{lesson}} -->
            <div class="d-inline-block" :class="lesson.status.value == 'OPENED' ? 't-color-whiteMedium' : 't-color-whiteMedium'">
                <span class="t-body3 font-r d-block" :class="{'t-color-red': lesson.progressionId === currentProgressionId}">
                    {{lesson.name}}
                </span>
                <span class="t-helper font-r d-block mgt-2 t-color-whiteDisabled">
                    {{lesson.contentsType.text}}
                    | {{lesson.rate}}%
                </span>
            </div>
        </li>
    </ul>
</template>

<script>
/**
 * 학습창 레슨 목록
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.08
 */

// Components/Mixin/Extend/API 선언
export default {
    props: ['lessonsList', 'currentProgressionId'],
    // data() {
    //     return
    // },
    mounted(){
    },
    methods: {
        // 시간 변환 함수 - Todo 필터로 교체
        parseSecondsToMinutes: function (seconds) {
            seconds = Math.round(seconds); // Need this to remove any numbers after period.
            let minutes = 0;
            while (seconds >= 60) {
                minutes++;
                seconds -= 60;
            }

            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            if (seconds < 10) {
                seconds = '0' + seconds;
            }

            return minutes + ':' + seconds;
        },

        moveNextLesson(lesson) {
            if (lesson.status.value === 'OPENED' ) {
                if (this.currentProgressionId === lesson.progressionId) {
                    // this.$alert({
                    //     // title: '현재학습',
                    //     content: 'Todo-현재 학습중인 레슨입니다.',
                    //     accept:  'Todo-확인',
                    // }).then(() => {})
                }else {
                    // let learnId = this.$route.params.learnId

                    // this.$router.push(`/learn/${learnId}/lessonContents/${lesson.progressionId}`)
                    if (lesson.contentsType.value === 'EXAM_PAPER') {
                        //document.body.requestFullscreen()
                        this.$router.push({
                            name: 'LessonExamIntro',
                            params: {
                                learnId: this.$route.params.learnId,
                                examineeId: lesson.examineeId
                            },
                            query: this.$route.query
                        })
                    }else {
                        //document.body.requestFullscreen()
                        this.$router.push({
                            name: 'LessonView',
                            params: {
                                learnId: this.$route.params.learnId,
                                lessonId: lesson.id,
                                progressionId: lesson.progressionId
                            },
                            query: this.$route.query
                        })
                    }
                }
            }else {
                this.$alert({
                   // title: 'Todo-순차학습 안내',
                    content: '<div id="slidePopup" >'+this.$t('1885')+"<br/>"+this.$t('1886')+'</div>',
                    accept:  this.$t('1887'),
                    
                }).then(() => {})
            }
            
        }
    }
    

}
</script>

<style scoped>


</style>